import api from ".";

const path = "/admin/me/settings/payment-processors";

const apiPaymentProcessors = api(path, {});
export default apiPaymentProcessors;
